"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const material_1 = require("@mui/material");
const MneListItem_1 = tslib_1.__importDefault(require("../components/MneListItem"));
const MneListItemText_1 = tslib_1.__importDefault(require("../components/MneListItemText"));
const MenuComponentSwitch_1 = tslib_1.__importDefault(require("./MenuComponentSwitch"));
const MenuCategory = ({ items, label, open, ...rest }) => (react_1.default.createElement(material_1.List, { disablePadding: true, sx: {
        paddingTop: open ? 2 : 0,
        // If this is the first element of type `ul` of its siblings.
        // Set `opacity` of all `Divider` children to 0.
        ":first-of-type": {
            ".MuiDivider-root": {
                opacity: 0,
            },
        },
    } },
    react_1.default.createElement(MneListItem_1.default, { key: label, disablePadding: true, ...rest.ListItemProps },
        open && (react_1.default.createElement(MneListItemText_1.default, { open,
            primary: label,
            primaryTypographyProps: { variant: "overline" },
            sx: { pl: 0, mb: 0 },
            ...rest.ListItemTextProps })),
        !open && (react_1.default.createElement(material_1.Divider, { sx: {
                width: (theme) => theme.spacing(4.5),
                // Uses text.secondary to match the icons
                borderColor: (theme) => theme.palette.text.secondary,
            } }))),
    react_1.default.createElement(MenuComponentSwitch_1.default, { items: items, open: open })));
exports.default = MenuCategory;
